/**
 * FileIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const FileIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m19.71 6.71-4.42-4.42a1 1 0 0 0-.7-.29H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.41a1 1 0 0 0-.29-.7M6 20V4h7v4a1 1 0 0 0 1 1h4v11z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const FileIcon = makeIcon('FileIcon', FileIconSvg)
